import script from "./AffiliateForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateForgotPassword.vue?vue&type=style&index=0&id=90d9f160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90d9f160"]])

export default __exports__